<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
		<v-card max-height="600px">
			<v-toolbar flat color="primary"></v-toolbar>
			<v-divider></v-divider>
            <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <h2 class="text-center">Você está excluindo a aula "{{aula.nome}}"</h2>
                        <h3 class="text-center">Confirma a exclusão?</h3>
                    </v-col>
                </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="confirmar()">Confirmar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Cancelar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>

import { baseApiUrl, showError, showSuccess } from "@/config/global"
import axios from 'axios'


export default {
    name: 'ExcluirAula',
    props:['aula', 'mostrar'],
    data(){
        return{
            
        }
    },

    methods:{
        confirmar(){
            const url = `${baseApiUrl}/Cursos/deleteAula.php`

            axios.post(url, {id: this.aula.id})
            .then(res => {
                if(res.data.codigo == '01'){
                    showSuccess(res.data.mensagem)
                    this.$emit('aulaExcluida', this.aula.id)
                }else{
                    showError(res.data.mensagem)
                }
            })
        },
            
            fechar(){
                this.$emit('fecharExcluir')
            }
    },
}
</script>

<style scoped>

</style>